import { imagePath } from "../../../../utils/imagePath";

const ArTechnologyData = {
    slug: 'concepts/ar',
    sectionTitle: 'AR Technology',
    blocks: [
      {
        type: 'text',
        content: [
          'Augmented Reality (AR) enhances the real world by **adding digital elements—such as 3D models, animations, text, or effects—on top of what you see around you.** Unlike virtual reality, AR does not replace your environment. Instead, it builds on it.',
          'When you use AR through a smartphone, tablet, or headset, the device’s camera and sensors understand the physical space and place digital content so it appears naturally anchored in the real world.',
        ],
      },
      {
        type: 'image',
        src: imagePath?.ARTecnology,
        alt: 'Dashboard',
      },
    ],
    subSections: [
      {
        title: '1.1 What You Can Experience with AR',
        blocks: [
          {
            type: 'text',
            content: ['AR enables experiences such as:'],
          },
          {
            type: 'list',
            style: 'disc',
            items: [
              'Viewing **3D objects** in real-world spaces',
              'Interactive **animations and effects** layered onto environments',
              'Contextual **information overlays** (labels, guides, instructions)',
              'Immersive storytelling and product visualization',
            ],
          },
          {
            type: 'text',
            content: [
              'All interactions happen in real time, making the experience feel natural and engaging.',
            ],
          },
        ],
      },
      {
        title: '1.2 Why AR Feels Real',
        blocks: [
          {
            type: 'text',
            content: ['AR adapts to the real world by:'],
          },
          {
            type: 'list',
            style: 'disc',
            items: [
              'Matching **scale and position** of digital objects',
              'Responding to **lighting and movement**',
              'Staying anchored to physical surfaces',
            ],
          },
          {
            type: 'text',
            content: [
              'This creates the illusion that digital content truly belongs in the space around you.',
            ],
          },
        ],
      },
      {
        title: '1.3 What Makes AR Interactive',
        blocks: [
          {
            type: 'text',
            content: 'AR experiences are dynamic and responsive:',
          },
          {
            type: 'list',
            style: 'disc',
            items: [
              'Digital objects stay anchored to real-world surfaces',
              'Content responds to user movement and gestures',
              'Animations and effects play in real time',
              'Interactions feel natural and immediate',
            ],
          },
          {
            type: 'text',
            content:
              'This creates a seamless connection between the physical and digital worlds.',
          },
        ],
      },
    ],
}
  
export default ArTechnologyData;